






























import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import abpbase from "@/lib/abpbase";
// import {routers} from '@/router/router';
import {EMPTY_ARRAY} from "@/lib/appconst";
import ajaxHelperInstance from "@/lib/ajaxhelper";
import util from "@/lib/util";

// import sectionLayout from "@/layouts/sectionLayout.vue";

interface keywordCardData {
  title: string,
  subTitle: string,
  showSub?: boolean,
}


@Component({
  name: 'keywordCard',
  components: {
    // sectionLayout
  }
})
export default class keywordCard extends abpbase {
  @Prop({type: String, default: ''}) keywords;
  @Prop({type: String, default: '1'}) docType;
  @Prop({type: String, default: ''}) id;
  // @Prop({type: Array, default: EMPTY_ARRAY}) data: Array<keywordCardData>;

  activeKey: string[] = [];
  data: Array<keywordCardData> = [];

  // @Emit("click-item")
  clickItem(e) {
    let func = {
      '2': this.openQAItem,
      '1': this.openKnowItem
    }
    let targetFunc = func[e.type];
    targetFunc(e);
  }

  handleMouseenter(index: string) {
    this.activeKey = [`item_${index}`];
  }

  handleMouseout() {
    this.activeKey = ['-1'];
  }

  openQAItem(item) {
    this.$router.push({
      name: 'QADetail',
      params: {
        queryParams: JSON.stringify({
          questionId: item.id
        })
      }
    })
  }

  openKnowItem(item) {
    let routerData = {
      docId: item.id
    }
    this.$router.push({
      name: 'knowledgeBaseDetail',
      params: {
        'queryParams': JSON.stringify(routerData)
      }
    })
  }

  loadData() {
    let self = this;
    let reqParam = {
      keyWords: this.keywords,
      currentPage: 1,
      moduleType: this.docType,
      id: this.id
    };
    let _this = this;
    if (_this.keywords) {
      ajaxHelperInstance.get('/web/global/query', reqParam).then(res => {
        let {data, errno, message} = res.data;
        if (errno == 0 && data) {
          let cMap: any[] = data.map(function (p) {
            return {
              "id": p.docId,
              "title": util.removeHtml(p.title),
              "subTitle": util.removeHtml(p.content),
              type: self.docType,
              'showSub': false
            };
          });
          //title不会有重复的
          _this.data = cMap.filter(item => {
            return item.title !== _this.keywords;
          });
        }
      })
    }
  }

  @Watch('keywords')
  keywordsChanged() {
    this.loadData();
  }

  init() {
    this.$nextTick(() => {
      this.loadData();
    });
  }

  mounted() {
    this.init();
  }
}
